export const lang = {
    headerDescription: 'Визуализация и отслеживание загрязнения побережья для чистого будущего',
    dragDropPlaceholder: 'Перетащите файлы сюда',
    dragDropFileFormat: '.jpg, .png, .zip',
    progressBarPlaceholder: (completed: number, total: number) =>
        `Загружено ${completed} из ${total} файлов...`,
    github: 'Github',
    mail: 'Mail',
    trashByTypes: 'Мусор по типу',
    trashByValues: 'Всего обнаружено',
    volume: 'Объем',
    mass: 'Масса',
    area: 'Площадь',
    noValue: 'Нет данных ',
    massMeasure: 'кг',
    areaMeasure: 'м²',
    volumeMeasure: 'м³',
    itemsMeasure: 'шт',
    waiting: 'Ожидание',
    inProgress: 'Обработка',
    completed: 'Выполнено',
    error: 'Ошибка',
    cancel: 'Отменено',
    unpacking: 'Распаковка',
    threeDot: '...',
    close: 'Закрыть',
    status: 'Статус',
    size: 'Размер',
}
